<template>
  <div style="overflow-x: hidden;">
    <b-card>
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>申请人：</span>
            </div>
            <div class="showText">
              <span>{{ formData.salesPersonName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>申请日期：</span>
            </div>
            <div class="showText">
              <span>{{ formData.requestDate }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>申请方式：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_oaExpenseProcess }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>付款用途：</span>
            </div>
            <div class="showText">
              <span>{{ formData.remark }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>付款说明：</span>
            </div>
            <div class="showText">
              <span>{{ formData.description }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>备注：</span>
            </div>
            <div class="showText">
              <span>{{ formData.notes }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </b-card>
    <b-card>
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>付款公司：</span>
            </div>
            <div class="showText">
              <span>{{ formData.expensePayerName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>费用合计：</span>
            </div>
            <div class="showText">
              <span
                >{{ formData.v_currencyAmount }}
                {{ formData.v_currencyUnit }}</span
              >
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>付款方式：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_paymentMethod }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </b-card>
    <b-card>
      <el-row :gutter="10">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>收款方：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_payeeType }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>收款单位：</span>
            </div>
            <div class="showText">
              <span>{{ formData.payeeName }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>收款银行：</span>
            </div>
            <div class="showText">
              <span>{{ formData.bankName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>账户名称：</span>
            </div>
            <div class="showText">
              <span>{{ formData.bankAccountName }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>银行账号：</span>
            </div>
            <div class="showText">
              <span>{{ formData.bankAccountNo }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>账户性质：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_bankAccountType }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>账号类别：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_bankAccountKind }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="!oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>代用发票：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_substituteInvoice }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="!oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>转送总经理：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_forwardGeneralManager }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="!oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>业务消费：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_businessConsumption }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="!oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>420：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_otherSet }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 6 }"
          v-if="!oaExpenseProcessIsA"
        >
          <div class="d-flex">
            <div class="showTitle">
              <span>费用大类：</span>
            </div>
            <div class="showText">
              <span>{{ formData.v_costCategory }}</span>
            </div>
          </div>
        </el-col>

        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <div>
            <div class="d-flex mt-2">
              <div class="side-frame-success"></div>
              <div>
                <span style="font-size: 14px; color: #606266">
                  费用明细
                </span>
              </div>
            </div>
            <ItemTable
              ref="itemTable"
              class="mb-2"
              :tableData="formData.listItem"
            />
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 24 }"
          :lg="{ span: 24 }"
        >
          <div>
            <div class="d-flex mt-2">
              <div class="side-frame-warning"></div>
              <div>
                <span style="font-size: 14px; color: #606266">
                  附件文档
                </span>
              </div>
            </div>
            <DocTable
              ref="docTable"
              class="mb-2"
              :tableData="formData.listDoc"
            />
          </div>
        </el-col>
      </el-row>
    </b-card>
  </div>
</template>
<script>
import ItemTable from '../item-table'
import DocTable from '../doc-table'
export default {
  components: { ItemTable, DocTable },
  props: {
    amzExpenseCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
    }
  },
  computed: {
    oaExpenseProcessIsA() {
      return this.formData.oaExpenseProcess == 'A'
    },
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f1f1f1;')
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.amzExpenseCode) return
      this.$api.opaEcomAmzExpenseApi(this.amzExpenseCode).then((res) => {
        this.formData = res.body
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  margin: 10px 10px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.showTitle {
  font-size: 14px;
  color: $color-text-sub;
  width: 100px;
}
.showText {
  font-size: 14px;
  color: $color-text-normal;
  width: 100%;
}
</style>
